import ContentService from '@/services/api/content/content-service.js';
import ListService from '@/services/api/list/list-service.js';

const state = {
  content: [],
  contentQueue: {
    ots: [],
    custom: [],
  },
  contentListGroup: [],
  currentListId: undefined,
  downloadQueue: {
    ots: [],
    custom: [],
  },
  listQueue: [],

};

const getters = {
  content: state => state.content,
  contentQueue: state => state.contentQueue,
  downloadQueue: state => state.downloadQueue,
  contentListGroup: state => state.contentListGroup,
  currentListId: state => state.currentListId,
  listQueue: state => state.listQueue,
};

const mutations = {
  setContent: (state, data) => {
    state.content = data;
  },
  initDownloadQueue: (state) => {
    if (localStorage.getItem('download-queue')) {
      state.downloadQueue = JSON.parse(localStorage.getItem('download-queue'));
    }
  },
  setContentQueue: (state, { data, type }) => {
    let body = { ots: [], custom: [] };
    if (type !== undefined) {
      body = {
        ots: type === 'ots' ? data : state.contentQueue.ots,
        custom: type === 'custom' ? data : state.contentQueue.custom,
      };
    }
    state.contentQueue = body;
  },
  setDownloadQueue: (state, { data, type }) => {
    let body = { ots: [], custom: [] };
    if (type !== undefined) {
      body = {
        ots: type === 'ots' ? data : state.downloadQueue.ots,
        custom: type === 'custom' ? data : state.downloadQueue.custom,
      };
    }

    localStorage.setItem('download-queue', JSON.stringify(body));
    state.downloadQueue = body;
  },
  setContentProfile: (state, { syncguid, profile }) => {
    const found = state.content.find(c => c.syncguid === syncguid);
    if (found) {
      found.profile = profile;
    } else {
      state.content.push({ syncguid, profile });
    }
  },
  setContentCourseXML: (state, { syncguid, coursexml }) => {
    const found = state.content.find(c => c.syncguid === syncguid);
    if (found) {
      found.coursexml = coursexml;
    } else {
      state.content.push({ syncguid, coursexml });
    }
  },
  setContentQuiz: (state, { syncguid, quiz }) => {
    const found = state.content.find(c => c.syncguid === syncguid);
    if (found) {
      found.quiz = quiz;
    } else {
      state.content.push({ syncguid, quiz });
    }
  },
  setContentOutline: (state, { syncguid, outline }) => {
    const found = state.content.find(c => c.syncguid === syncguid);
    if (found) {
      found.outline = outline;
    } else {
      state.content.push({ syncguid, outline });
    }
  },
  setContentCaptions: (state, { syncguid, captions }) => {
    const found = state.content.find(c => c.syncguid === syncguid);
    if (found) {
      found.captions = captions;
    } else {
      state.content.push({ syncguid, captions });
    }
  },
  setContentSuggestedAlternatives: (state, { syncguid, suggestedAlternatives }) => {
    const found = state.content.find(c => c.syncguid === syncguid);
    if (found) {
      found.suggestedAlternatives = suggestedAlternatives;
    } else {
      state.content.push({ syncguid, suggestedAlternatives });
    }
  },
  setListQueue(state, data) {
    state.listQueue = data;
  },
  setContentListGroup(state, data) {
    state.contentListGroup = data;
  },
  setCurrentListId(state, id) {
    state.currentListId = id;
  },
  setContentObject: (state, { syncguid, key, object }) => {
    const found = state.content.find(c => c.syncguid === syncguid);
    if (found) {
      found[key] = object;
    } else {
      const newContent = { syncguid };
      newContent[key] = object;
      state.content.push(newContent);
    }
  },
  removeContentItem: (state, { key, item, syncguid }) => {
    const content = state.content.find(c => c.syncguid === syncguid);
    if (content) {
      content[key] = content[key].filter(i => i !== item);
    }
  },
};

const actions = {
  getContentObject({ getters, commit }, { syncguid, key }) {
    const found = getters.content.find(c => c.syncguid === syncguid);
    if (found && found[key]) {
      return new Promise(resolve => {
        resolve(found[key]);
      });
    } else {
      const method = `get${key.charAt(0).toUpperCase() + key.slice(1)}`;
      return ContentService[method](syncguid).then(object => {
        commit('setContentObject', { syncguid, key, object });
        return object;
      });
    }
  },
  getContentProfile({ getters, commit }, syncguid) {
    const found = getters.content.find(c => c.syncguid === syncguid);
    if (found && found.profile) {
      return new Promise(resolve => {
        resolve(found.profile);
      });
    } else {
      return ContentService.getContentProfile(syncguid).then(profile => {
        commit('setContentProfile', { syncguid, profile });
        return profile;
      });
    }
  },
  getContentQuiz({ getters, commit }, syncguid) {
    const found = getters.content.find(c => c.syncguid === syncguid);
    if (found && found.quiz) {
      return new Promise(resolve => {
        resolve(found.quiz);
      });
    } else {
      return ContentService.getQuiz(syncguid).then(res => {
        const quiz = res.data;
        commit('setContentQuiz', { syncguid, quiz });
        return quiz;
      });
    }
  },
  getContentSuggestedAlternatives({ getters, commit }, syncguid) {
    const found = getters.content.find(c => c.syncguid === syncguid);
    if (found && found.suggestedAlternatives) {
      return new Promise(resolve => {
        resolve(found.suggestedAlternatives);
      });
    } else {
      return ContentService.getSuggestedAlternatives(syncguid).then(suggestedAlternatives => {
        commit('setContentSuggestedAlternatives', { syncguid, suggestedAlternatives });
        return suggestedAlternatives;
      });
    }
  },
  getContentListGroup({ commit, getters }) {
    const contentListGroup = getters.contentListGroup;
    if (contentListGroup.length > 0) {
      return new Promise(resolve => resolve(contentListGroup));
    }
    return ListService.getLists().then(res => {
      commit('setContentListGroup', res);
      return res;
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
